@if (view$ | async; as view) {
    @if (view.noDataFromApi) {
        <div class="alert alert-warning text-center m-3" role="alert">
            {{
                ('table_NO_DATA_FROM_SOURCE' | translate: 'online' : 'common')
                    .replace('{0}', 'event-alarms_event_alarms' | translate)
                    .replace('{1}', 'event-alarms_create-event-alarm' | translate)
            }}
        </div>
    } @else {
        <div class="table-responsive w-100">
            <table class="table table-striped table-sm">
                <thead>
                    <tr>
                        @for (head of view.columns; track $index) {
                            <th
                                app-sortable-table-header
                                [column]="head.columnKey"
                                (sort)="
                                    onSort({column: head.columnKey, direction: $event.direction})
                                "
                                [label]="
                                    head.labelTranslation?.key
                                        ? (head.labelTranslation!.key | translate)
                                        : ''
                                "></th>
                        }
                        <th></th>
                    </tr>
                    <tr [formGroup]="formGroupFilter">
                        @for (head of view.columns; track $index) {
                            <th class="align-top">
                                @if (head.formType === 'text') {
                                    <app-input-text-group [formControlName]="head.columnKey" />
                                }
                                @if (head.formType === 'selectMultiple') {
                                    <app-input-dropdown-checkboxes
                                        [formControlName]="head.columnKey" />
                                }
                            </th>
                        }
                        <th></th>
                    </tr>
                </thead>
                <tbody class="text-nowrap">
                    @for (eventAlarm of view.eventAlarms; track $index) {
                        <tr>
                            <td class="text-center">
                                @if (eventAlarm.meterModelCriteriaMismatch) {
                                    <i class="bi bi-exclamation-circle-fill text-warning"></i>
                                } @else {
                                    <i class="bi bi-check-circle-fill text-success"></i>
                                }
                            </td>
                            <td>
                                {{ eventAlarm.alarmName }}
                            </td>
                            <td>
                                {{ eventAlarm.eventTypeId | eventAlarm }}
                            </td>
                            <td>
                                @for (vendorModel of eventAlarm.vendorModels; track $index) {
                                    {{
                                        'mappers_meterType.' + vendorModel.meterType
                                            | translate: 'online' : 'common'
                                    }}
                                    - {{ vendorModel.modelName }}
                                    @if (!$last) {
                                        <br />
                                    }
                                }
                            </td>
                            <td style="width: 30px" class="last-col">
                                <div ngbDropdown placement="bottom-right" container="body">
                                    <button
                                        class="btn btn-link btn-sm"
                                        id="dropdownMeterActions"
                                        ngbDropdownToggle
                                        style="float: right">
                                        <i class="bi bi-three-dots-vertical"></i>
                                    </button>
                                    <div ngbDropdownMenu>
                                        <button
                                            ngbDropdownItem
                                            (click)="editAlarm.emit(eventAlarm.subscriptionId)">
                                            {{ 'common_Edit' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="
                                                duplicateAlarm.emit(eventAlarm.subscriptionId)
                                            ">
                                            {{ 'monitoring_duplicate' | translate }}
                                        </button>
                                        <button
                                            ngbDropdownItem
                                            (click)="deleteEventAlarm.emit(eventAlarm)">
                                            {{ 'common_Delete' | translate }}
                                        </button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="20" class="text-center">
                                {{ 'table_noResults' | translate: 'online' : 'common' }}
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        <div class="text-center">
            <app-pagination
                [collectionSize]="view.collectionSize"
                [page]="view.page"
                (pageChange)="setPage($event)"
                (pageSizeChange)="setPageSize($event)"></app-pagination>
        </div>
    }
} @else {
    <app-load />
}
